import AlimentationFilter from "./AlimentationFilter"

export default  AlimentationFilter;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/AlimentationFilter/index.js